import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import contentData from './data/content.json'

// Extract translations from content.json
const resources = {
  en: {
    translation: contentData.locales.en
  },
  es: {
    translation: contentData.locales.es
  }
}

i18n
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'es'],
    load: 'languageOnly', // Load 'en' instead of 'en-GB'
    defaultNS: 'translation',

    interpolation: {
      escapeValue: false // React already escapes
    },

    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'i18nextLng',
      convertDetectedLanguage: (lng) => lng.split('-')[0] // Convert 'en-GB' to 'en'
    }
  })

export default i18n
